import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Storage from 'vue-ls'
import App from './App'
import router from './router'
import axios from 'axios'
import vmodal from 'vue-js-modal'
import VueSweetalert2 from 'vue-sweetalert2'
import moment from 'moment/dist/moment'
import vueMoment from 'vue-moment'
import MobileDetect from 'mobile-detect'
import { Notifier } from '@airbrake/browser'
import { createPinia, PiniaVuePlugin } from 'pinia'
import Sugar from 'sugar'
import { datePicker, status, statusVariant } from '@/variables'
import '@/assets/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import mixpanel from 'mixpanel-browser'
import VueShortkey from 'vue-shortkey'
import { registerSW } from 'virtual:pwa-register'

registerSW({ immediate: true })
// import OneSignalVue from 'onesignal-vue'

Sugar.extend()

import('moment/dist/locale/ja').then(() => {
    moment.locale('ja')
})

mixpanel.init(import.meta.env.VITE_MIXPANEL ?? 'DUMMY', {
    debug: !import.meta.env.PROD,
    api_host: 'https://mp.spo-plus.com',
    ignore_dnt: true
})
// Vue.use(OneSignalVue);
Vue.config.productionTip = false
Vue.use(VueShortkey)
Vue.use(BootstrapVue)
Vue.use(Storage, {
    name: 'ls',
    namespace: 'jaba__'
})
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.use(vmodal)
Vue.use(VueSweetalert2)
Vue.use(vueMoment, {
    moment
})
Vue.prototype.$md = new MobileDetect(navigator.userAgent)
Vue.prototype.$log = function (event, data) {
    // mixpanel.track(event, data)
    window.gtag('event', event, data)
}

const baseURL = import.meta.env.VITE_API ?? '/api/'
Vue.prototype.$http = axios.create({
    baseURL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        post: {
            'Content-Type': 'application/json'
        }
    }
})

Vue.prototype.$baseUrl = baseURL

Vue.prototype.$copy = function (object) {
    return JSON.parse(JSON.stringify(object))
}

Vue.prototype.$env = function () {
    return process.env
}

Vue.prototype.$http.interceptors.response.use((response) => {
    // Do something with response data
    return response
}, (error) => {
    if (error.response) {
        if (error.response.status && error.response.status === 503) {
            document.querySelector('#maintenance').style.display = 'block'
        }
        /*
        switch (error.response.status) {
          case 404:
            Vue.snotify.error('指定した映像が存在しない');
            break;
          case 403:
            Vue.snotify.error('復元する権限がありません');
            break;
          default:
            if (error.response.data && error.response.data.error) {
              Vue.snotify.error(error.response.data.error);
            } else {
              Vue.snotify.error('サーバーエラー');
            }
            break;
        }
         */
    } else if (error.request) {
        console.log(error.request)
        Vue.prototype.$snotify.error(error.message)
    } else {
        Vue.prototype.$snotify.error(error.message)
        console.log(error.config)
    }
    return Promise.reject(error)
})
let guid = Vue.ls.get('guid')
if (!guid) {
    import('@fingerprintjs/fingerprintjs').then(module => {
        module.default.load().then(fp => {
            return fp.get()
        }).then(r => {
            guid = r.visitorId
            Vue.ls.set('guid', guid)
        })
    })
}

Vue.prototype.$loggedIn = function () {
    return Vue.ls.get('user', null) !== null && Vue.ls.get('token', null) !== null
}

Vue.prototype.$guid = function () {
    if (!guid && Vue.ls.get('guid')) {
        return Vue.ls.get('guid')
    }
    return guid
}

/*
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 4000
  }
}
*/

Vue.prototype.$toast = Vue.swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000
})

Vue.prototype.$getComponent = function (componentName) {
    let component = null
    let parent = this.$parent
    while (parent && !component) {
        if (parent.$options.name === componentName) {
            component = parent
        }
        parent = parent.$parent
    }
    return component
}

Vue.prototype.$snotify = {
    error (text, title) {
        Vue.prototype.$toast.fire({
            type: 'error',
            text,
            title
        })
    },
    warning (text, title) {
        Vue.prototype.$toast.fire({
            type: 'warning',
            text,
            title
        })
    },
    info (text, title) {
        Vue.prototype.$toast.fire({
            type: 'info',
            text,
            title
        })
    },
    success (text, title) {
        Vue.prototype.$toast.fire({
            type: 'success',
            text,
            title
        })
    }
}

router.afterEach((to) => {
    mixpanel.track_pageview({
        page: to.path,
        title: document.title
    })

    window.gtag('page_view', {
        page_title: document.title,
        page_path: to.path
    })
})

// Vue.use(Snotify, options)

if (import.meta.env.PROD) {
    Vue.prototype.$ab = new Notifier({
        projectId: 322672,
        projectKey: 'ed4478782c5a32340c4aa5f2e7aebd09',
        environment: process.env.NODE_ENV
    })
    Vue.prototype.$ab.addFilter((notice) => {
        if (Vue.prototype.$loggedIn()) {
            notice.session = {
                username: Vue.ls.get('user', null)
            }
        }
        // eslint-disable-next-line no-undef
        notice.context.version = __APP_VERSION__
        return notice
    })
    Vue.config.errorHandler = function (err, vm, info) {
        Vue.prototype.$ab.notify({
            error: err,
            params: { info }
        })
    }
    // window.addEventListener('error', event => {
    //     Vue.prototype.$ab.notify({
    //         error: event.error,
    //         params: {event: event}
    //     });
    // });
    // window.addEventListener('unhandledrejection', event => {
    //     Vue.prototype.$ab.notify({
    //         error: event.reason,
    //         params: {event: event}
    //     });
    // });
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    pinia,
    data () {
        return {
            datePicker,
            status,
            statusVariant
        }
    },
    created () {
        const t = this.$ls.get('token')
        if (t) {
            this.$http.defaults.headers.Authorization = 'Token ' + t
        }
        const csrftoken = getCookie('csrftoken')
        if (csrftoken) {
            this.$http.defaults.headers['X-CSRFToken'] = csrftoken
        }
    },
    render: h => h(App)
    // beforeMount() {
    //     const user = this.$ls.get('user')
    //     if (user) {
    //         this.$OneSignal.init({ appId: 'e672c592-1772-48a7-8e7b-f9afd96d3c69' }).then(() => {
    //             this.$OneSignal.login(user.username);
    //         });
    //     }
    // }
})

function getCookie (name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                break
            }
        }
    }
    return cookieValue
}
